module.exports = __webpack_public_path__ + "static/media/News01.1926cd85.jpg";